const isMinHeightBox = (el) =>
  el?.tagName === 'DIV' && /min-height:\s*200px/i.test(el.getAttribute('style') || '');

const isWrapper = (el) =>
  el?.tagName === 'DIV' && /padding:\s*20px/i.test(el.getAttribute('style') || '');

const soleElementChild = (el) => {
  const hasText = Array.from(el.childNodes).some((n) => n.nodeType === 3 && n.textContent.trim());
  if (hasText || el.children.length !== 1) return null;
  return el.children[0];
};

// Template wrapper (padding box > min-height box) gets re-applied on every save,
// nesting it N levels deep. Collapse chains: M > W > M2 => M.
export const collapseEmailWrappers = (html) => {
  if (typeof html !== 'string' || !/min-height:\s*200px/i.test(html)) return html;
  try {
    const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
    let changed = true;
    while (changed) {
      changed = false;
      const boxes = doc.body.querySelectorAll('div');
      for (const m of boxes) {
        if (!isMinHeightBox(m)) continue;
        const w = soleElementChild(m);
        if (!isWrapper(w)) continue;
        const m2 = soleElementChild(w);
        if (!isMinHeightBox(m2)) continue;
        m.replaceChildren(...Array.from(m2.childNodes));
        changed = true;
        break;
      }
    }
    return doc.body.innerHTML;
  } catch (e) {
    return html;
  }
};

export default collapseEmailWrappers;
